import React from 'react'
import { Pre } from '@maui/elements'

export function HashText({ children, ...textProps }) {
  const { value, fontColor } = textProps
  return (
    <Pre
      margin='0'
      color={fontColor}
      fontSize='12px'
      lineHeight='16px'
      fontWeight='400'
      textOverflow='ellipsis'
      overflow='hidden'
      maxWidth='450px'
      {...textProps}
    >
      {value?.length > 32
        ? value?.slice(0, 12) + ' ..... ' + value?.slice(21, 34)
        : value}
    </Pre>
  )
}

export default HashText
